import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  confirmButton?: string;
  cancelText?: string;
  cancelButton?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="confirm-dialog">
      <div class="confirm-header">
        <h2>{{ data.title }}</h2>
      </div>
      <div class="confirm-body">
        <p>{{ data.message }}</p>
      </div>
      <div class="confirm-actions">
        <button type="button" class="btn-cancel" (click)="dialogRef.close(false)">
          {{ data.cancelButton || data.cancelText || 'Abbrechen' }}
        </button>
        <button type="button" class="btn-confirm" (click)="dialogRef.close(true)">
          {{ data.confirmButton || data.confirmText || 'Ok' }}
        </button>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; overflow: hidden; }
    .confirm-dialog { width: 100%; box-sizing: border-box; overflow: hidden; }
    .confirm-header {
      color: #fff;
      padding: 14px 24px;
      margin: -24px -24px 0 -24px;
    }
    .confirm-header h2 { margin: 0; font-size: 17px; font-weight: 600; }
    .confirm-body { padding: 20px 0 12px 0; }
    .confirm-body p { font-size: 14px; color: #374151; line-height: 1.6; margin: 0; }
    .confirm-actions {
      display: flex; justify-content: center; gap: 14px;
      padding-top: 14px; border-top: 1px solid #e5e7eb;
    }
    .btn-cancel, .btn-confirm {
      border-radius: 6px; padding: 8px 28px;
      font-size: 13px; font-weight: 500; cursor: pointer;
      min-width: 100px; text-align: center;
      transition: background 0.15s;
    }
    .btn-cancel {
      background: #f3f4f6; color: #374151; border: 1px solid #d1d5db;
    }
    .btn-cancel:hover { background: #e5e7eb; }
    .btn-confirm {
      background: #4358a6; color: #fff; border: none;
    }
    .btn-confirm:hover { background: #374b8a; }
  `]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}
}
